import { render, staticRenderFns } from "./Traslados.vue?vue&type=template&id=ebb1c392&"
import script from "./Traslados.vue?vue&type=script&lang=js&"
export * from "./Traslados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports